var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isExpired)?_c('div',[_vm._v("\n  "+_vm._s(_vm.days)+" days | "+_vm._s(_vm.hours)+" h | "+_vm._s(_vm.minutes)+" m | "),_c('span',{staticClass:"w-7 inline-block text-left"},[_vm._v(_vm._s(_vm.seconds)+" s")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }